var _a;
/* eslint-disable no-unused-vars */
import ttiPolyfill from 'tti-polyfill';
import { getExtendedLogger } from '../components/Logger';
import logger from '../config/app.logger';
var log = getExtendedLogger('tti', logger);
export var getTTIPromise = function (maxDelay) {
    maxDelay = maxDelay || 10000;
    var tti = ttiPolyfill
        .getFirstConsistentlyInteractive({ useMutationObserver: false })
        .then(function (tti) { return log("[TTI]: " + tti); })
        .then(function () { return true; });
    var race = new Promise(function (resolve) { return setTimeout(function () { return resolve(false); }, maxDelay); });
    return Promise.race([tti, race]).then(function (fromTTI) {
        var msg = "[Race] Timeout won for maxDelay " + maxDelay;
        if (fromTTI) {
            msg = "[Race] TTI won for maxDelay " + maxDelay;
        }
        log(msg);
        return msg;
    });
};
export var DELAYS;
(function (DELAYS) {
    DELAYS[DELAYS["S"] = 3000] = "S";
    DELAYS[DELAYS["L"] = 10000] = "L";
    DELAYS[DELAYS["XL"] = 15000] = "XL";
})(DELAYS || (DELAYS = {}));
export var singletonTTIPromises = (_a = {},
    _a[DELAYS.S] = getTTIPromise(DELAYS.S),
    _a[DELAYS.L] = getTTIPromise(DELAYS.L),
    _a[DELAYS.XL] = getTTIPromise(DELAYS.XL),
    _a);
//# sourceMappingURL=tti.js.map